type SubscribeToAttachSignal = (
  onSignal: () => void
) => (() => void) | Promise<() => void>;

const ATTACH_RETRY_TIMEOUT_MS = 5_000;

export async function waitForAttachSignalOrTimeout(
  subscribe: SubscribeToAttachSignal
): Promise<void> {
  let unsubscribe: (() => void) | undefined;
  let finish: () => void = () => undefined;
  let didSettle = false;

  const released = new Promise<void>((resolve) => {
    finish = () => {
      if (didSettle) return;
      didSettle = true;
      window.clearTimeout(timer);
      unsubscribe?.();
      resolve();
    };

    const timer = window.setTimeout(finish, ATTACH_RETRY_TIMEOUT_MS);
  });

  try {
    const nextUnsubscribe = await subscribe(finish);
    if (didSettle) {
      nextUnsubscribe();
    } else {
      unsubscribe = nextUnsubscribe;
    }
  } catch {
    finish();
  }

  return released;
}
